var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-role"},[_c('div',{staticClass:"avatar",class:{ botAvatar: _vm.isBot }}),_c('strong',[_vm._v(_vm._s(_vm.nickName))]),(_vm.isBot)?_c('div',{staticClass:"bot"},[_vm._v("bot")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }